"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = TextArea;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useFormInputFetch = _interopRequireDefault(require("../shared/stateFunctions/useFormInputFetch"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function TextArea(props) {
  var label = props.label,
      _props$initialValue = props.initialValue,
      initialValue = _props$initialValue === void 0 ? "" : _props$initialValue,
      cbSuccess = props.cbSuccess;
  var input = (0, _useFormInputFetch.default)(initialValue, props.uid, props.name, props);

  var inputField = _react.default.createElement("textarea", _extends({
    type: "text",
    class: "form-control"
  }, input));

  var linkAction = _react.default.createElement("a", {
    href: "#",
    tabindex: "0",
    onClick: function onClick(e) {
      e.preventDefault();
      input.openEditMode();
    }
  }, input.value === "" || !input.value ? _react.default.createElement("span", {
    style: {
      color: "red"
    }
  }, _react.default.createElement("u", null, "Empty")) : input.value);

  var actionButtons = _react.default.createElement("div", null, _react.default.createElement("button", {
    class: "btn btn-outline-primary",
    type: "button",
    onClick: function onClick() {
      return input.save();
    }
  }, "Save"), _react.default.createElement("button", {
    class: "btn btn-outline-secondary ml-2",
    type: "button",
    onClick: input.cancelEdit
  }, "Cancel"));

  var helperText = _react.default.createElement("small", {
    style: {
      color: "gray"
    }
  }, props.helperText);

  function getAction() {
    if (input.isEdit) {
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        class: "form-row"
      }, _react.default.createElement("div", {
        class: "col-8"
      }, inputField), _react.default.createElement("div", {
        class: "col-auto"
      }, actionButtons)), helperText);
    } else {
      return linkAction;
    }
  }

  if (props.isCol) {
    return _react.default.createElement("div", null, _react.default.createElement("label", null, label), input.isEdit ? [_react.default.createElement("div", null, inputField), _react.default.createElement("div", null, helperText), _react.default.createElement("div", {
      className: "mt-2"
    }, actionButtons)] : _react.default.createElement("div", null, linkAction));
  }

  return _react.default.createElement("div", {
    className: "row m-0"
  }, _react.default.createElement("div", {
    className: "col-3"
  }, label), _react.default.createElement("div", {
    className: "col-9"
  }, getAction()));
}

var _default = TextArea;
exports.default = _default;